import React from "react";
import { DatavizHorizontalBarChart } from "@radarly/models/dataviz";
import { FullFacet } from "@radarly/models/facets";
import { getComparaisonPeriodFromFragments } from "@radarly/models/fragment";
import { SearchFragmentGeo } from "@radarly/models/search";
import { useFragmentsData } from "../../data";
import Loading from "../../loading";
import Inner from "./inner";

export interface SharedWidgetsGeoHorizontalBarChartProps {
  project: number;
  fragment: SearchFragmentGeo;
  evolutionFragment: SearchFragmentGeo;
  dataviz: DatavizHorizontalBarChart;
  facet: FullFacet;
  onClickGauge?: (uid: string | number) => void;
  className?: string;
  forceReload?: boolean;
  disableAnimation?: boolean;
  isFullscreen?: boolean;
  closeFullscreen?: () => void;
  isPNG?: boolean;
}

export default function SharedWidgetsGeoHorizontalBarChart({
  project,
  fragment,
  evolutionFragment,
  forceReload,
  isFullscreen,
  closeFullscreen,
  onClickGauge,
  ...props
}: SharedWidgetsGeoHorizontalBarChartProps) {
  const comparisonPeriod = getComparaisonPeriodFromFragments(
    fragment,
    evolutionFragment
  );
  const { loading, data, comparaisonData } = useFragmentsData(
    project,
    fragment,
    evolutionFragment
  );
  const _onClickGauge = (uid: string | number) => {
    if (isFullscreen) {
      closeFullscreen();
    }
    onClickGauge(uid);
  };
  return (
    <Loading loading={loading} forceReload={forceReload}>
      <Inner
        loading={loading}
        data={data}
        comparaisonData={comparaisonData}
        fragment={fragment}
        comparisonPeriod={comparisonPeriod}
        isFullscreen={isFullscreen}
        onClickGauge={_onClickGauge}
        {...props}
      />
    </Loading>
  );
}
